import { render, staticRenderFns } from "./SpotifyEmbed.vue?vue&type=template&id=682eb6f9"
import script from "./SpotifyEmbed.vue?vue&type=script&lang=js"
export * from "./SpotifyEmbed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports